// extracted by mini-css-extract-plugin
export var main = "WidIL";
export var mainModule = "dF701";
export var pageContent = "CmLIc";